export const operationTabs = {
  GENERAL: 1,
  DATA: 2,
  OPERATIONS: 3
}
